<template>
  <div class="Resource-application">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch"
      >
        <template v-slot:suffix>
          <label class="time-warp">时间</label>
          <el-date-picker
            v-model="value2"
            type="month"
            :picker-options="{'firstDayOfWeek': 1}"
            placeholder="选择月">
          </el-date-picker>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="tableData"
        :config="{trigger: 'click', mode: 'cell'}"
        :editable="true"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        :toolBar="{hidden: true}"
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";

export default {
  name: "ResourceUse",
  mixins: [DataTableMixin],
  components: {
    DynamicSearch
  },
  created() {
  },
  data() {
    return {
      valueRange: "",
      tableHead: [
        {
          label: "员工姓名",
          prop: "name",
          query: {
            type: "input"
          },
          fixed: "left",
          align: "center"
        },
        {
          label: "人员角色",
          prop: "type",
          query: {
            type: "select"
          },
          fixed: "left",
          align: "center"
        },
        /* {
          label: "时间",
          prop: "dateRange",
          query: {
            type: "date",
            dateType: "daterange",
            rangeSeparator: "——"
          },
          hidden: true
        }, */
        {
          label: "一月份",
          prop: "Janu",
          align: "center",
          children: [
            {
              label: "三",
              align: "center",
              children: [
                {
                  label: "01",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "四",
              align: "center",
              children: [
                {
                  label: "02",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "五",
              align: "center",
              children: [
                {
                  label: "03",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "六",
              align: "center",
              children: [
                {
                  label: "04",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "日",
              align: "center",
              children: [
                {
                  label: "05",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "一",
              align: "center",
              children: [
                {
                  label: "06",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "二",
              align: "center",
              children: [
                {
                  label: "07",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "三",
              align: "center",
              children: [
                {
                  label: "08",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "四",
              align: "center",
              children: [
                {
                  label: "09",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "五",
              align: "center",
              children: [
                {
                  label: "10",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "六",
              align: "center",
              children: [
                {
                  label: "11",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "日",
              align: "center",
              children: [
                {
                  label: "12",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "一",
              align: "center",
              children: [
                {
                  label: "13",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "二",
              align: "center",
              children: [
                {
                  label: "14",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "三",
              align: "center",
              children: [
                {
                  label: "15",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "四",
              align: "center",
              children: [
                {
                  label: "16",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "五",
              align: "center",
              children: [
                {
                  label: "17",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "六",
              align: "center",
              children: [
                {
                  label: "18",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "日",
              align: "center",
              children: [
                {
                  label: "19",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "一",
              align: "center",
              children: [
                {
                  label: "20",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "二",
              align: "center",
              children: [
                {
                  label: "21",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "三",
              align: "center",
              children: [
                {
                  label: "22",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "四",
              align: "center",
              children: [
                {
                  label: "23",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "五",
              align: "center",
              children: [
                {
                  label: "24",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "六",
              align: "center",
              children: [
                {
                  label: "25",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "日",
              align: "center",
              children: [
                {
                  label: "26",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "一",
              align: "center",
              children: [
                {
                  label: "27",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "二",
              align: "center",
              children: [
                {
                  label: "28",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "三",
              align: "center",
              children: [
                {
                  label: "29",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "四",
              align: "center",
              children: [
                {
                  label: "30",
                  align: "center",
                  width: "36"
                }
              ]
            },
            {
              label: "五",
              align: "center",
              children: [
                {
                  label: "31",
                  align: "center",
                  width: "36"
                }
              ]
            },
          ]
        }
      ],
      tableData: [{}]
    };
  },
  methods: {
    // 删除
    del(id) {
    },
    // 修改
    edit(data) {
    }
  }
};
</script>

<style lang="scss" scoped>
  /deep/ .page-filter-container {
    padding: 0 0 20px 0;
  }

  @media (max-width: 1024px) {
    .chart-wrapper {
      padding: 8px;
    }
  }

  .time-warp {
    padding-right: 5px;
    font-size: 14px;
    color: #606266;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
